const OPEN_LISSEN_BASE_URL = "https://open.lissen.com";

/** Whether `href` is a link into the Lissen app (one of the links below). */
export function isAppLink(href: string): boolean {
  return href === OPEN_LISSEN_BASE_URL || href.startsWith(`${OPEN_LISSEN_BASE_URL}/`);
}

export function buildArtistAppLink(artistId: string): string {
  return `${OPEN_LISSEN_BASE_URL}/explore/artist/${encodeURIComponent(artistId)}`;
}

export function buildSongAppLink(albumId: string, songId: string): string {
  return `${OPEN_LISSEN_BASE_URL}/explore/album/${encodeURIComponent(albumId)}/song/${encodeURIComponent(songId)}`;
}

export function buildAlbumAppLink(albumId: string): string {
  return `${OPEN_LISSEN_BASE_URL}/explore/album/${encodeURIComponent(albumId)}`;
}

export function buildAccessAppLink(accessId: string): string {
  return `${OPEN_LISSEN_BASE_URL}/access/${encodeURIComponent(accessId)}`;
}

/** An event the visitor holds tickets to: the app opens the tickets over
 *  their wallet, so closing them leaves the visitor in it. The tickets are
 *  named by the path alone: it is all a Branch install carries through. */
export function buildAccessTicketsAppLink(accessId: string): string {
  return `${buildAccessAppLink(accessId)}/view-tickets`;
}

/** The same tickets, in the app only: on a phone without it, open.lissen.com's
 *  `?app=1` sends the store, and the app opens them once installed
 *  (apps/open-redirect). */
export function buildAccessTicketsInstallLink(accessId: string): string {
  return `${buildAccessTicketsAppLink(accessId)}?app=1`;
}

/** A merch product the visitor ordered: the app opens their order of it
 *  (its order screen, where the order email's button also lands). */
export function buildMerchOrderAppLink(accessId: string): string {
  return `${buildAccessAppLink(accessId)}/my-order`;
}
